import { POST_UTENTI_NLT_V1 } from '../../constants/ActionTypes'
import { fetchData } from '../Buy'

export const postUtentiNltV1 = (dispatch, getState) => {
  if (getState().customer.token) {
    // ho gia' il token non faccio due volte la chiamata
    return new Promise(resolve => resolve())
  }

  return dispatch(
    fetchData(POST_UTENTI_NLT_V1)({
      method: 'POST',
      uri: `${window.brumbrum.url_api}/utenti/p/v1/u/1`,
      callback: POST_UTENTI_NLT_V1,
      errorMessage: POST_UTENTI_NLT_V1,
      body: JSON.stringify({
        email: getState().customer.email,
        name: getState().customer.name,
        surname: getState().customer.surname,
        phone: getState().customer.phone,
        id_auto: getState().product.id_auto,
      }),
    })
  )
}
